module.exports = __webpack_public_path__ + "img/rodape.57802d00.png";